import { Box, Stack } from '@mui/material'
import { com } from '@eidu/web'
import { PermissionWithId } from '../input/PermissionsInput'
import PolicyMultiSelect from '../input/PolicyMultiSelect'
import AppliedPoliciesList from '../input/AppliedPoliciesList'
import SelectorEditor from '../input/SelectorEditor'
import { PermissionPolicyDTO } from '../../domain/permission/PermissionPolicyDTO'
import PermissionsMatrix from './PermissionsMatrix'
import EntityType = com.eidu.sharedlib.entity.type.EntityType
import EntitySelector = com.eidu.sharedlib.entity.selector.EntitySelector
import EntityTypeKind = com.eidu.sharedlib.entity.type.EntityTypeKind
import PermissionPolicyId = com.eidu.sharedlib.entity.permission.PermissionPolicyId
import SectionHeader from '../layout/SectionHeader'

type PermissionGrantFormProps = {
  entityTypes: readonly EntityType[]
  userSelector: EntitySelector
  setUserSelector: (selector: EntitySelector) => void
  selectedPermissions: readonly PermissionWithId[]
  setSelectedPermissions: (permissions: readonly PermissionWithId[]) => void
  selectedPolicyIds: ReadonlyArray<PermissionPolicyId>
  setSelectedPolicyIds: (ids: ReadonlyArray<PermissionPolicyId>) => void
  loadedPolicies: ReadonlyArray<PermissionPolicyDTO>
  selectedPolicies: ReadonlyArray<PermissionPolicyDTO>
  hasMorePolicies: boolean
  loadMorePolicies: () => void
  policiesLoading?: boolean
}

const PermissionGrantForm = ({
  entityTypes,
  userSelector,
  setUserSelector,
  selectedPermissions,
  setSelectedPermissions,
  selectedPolicyIds,
  setSelectedPolicyIds,
  loadedPolicies,
  selectedPolicies,
  hasMorePolicies,
  loadMorePolicies,
  policiesLoading,
}: PermissionGrantFormProps) => (
  <Stack padding={0} spacing={2} sx={{ width: '100%', maxWidth: 1200, overflowX: 'auto' }}>
    <Box sx={{ border: 1, borderColor: 'divider', borderRadius: 1, overflow: 'hidden' }}>
      <SectionHeader title="Users" />
      <Box sx={{ p: 1 }}>
        <SelectorEditor
          selector={userSelector}
          onChange={setUserSelector}
          entityTypes={entityTypes.filter((type) => type.kind.equals(EntityTypeKind.Companion.User))}
          selectorType="target"
        />
      </Box>
    </Box>
    <Box sx={{ border: 1, borderColor: 'divider', borderRadius: 1, overflow: 'hidden' }}>
      <SectionHeader title="Policies" />
      <AppliedPoliciesList
        selectedPolicyIds={selectedPolicyIds}
        selectedPolicies={selectedPolicies}
        loading={policiesLoading}
        onRemove={(id) => setSelectedPolicyIds(selectedPolicyIds.filter((existing) => !existing.equals(id)))}
      />
      <PolicyMultiSelect
        loadedPolicies={loadedPolicies}
        selectedPolicies={selectedPolicies}
        selectedPolicyIds={selectedPolicyIds}
        onChange={setSelectedPolicyIds}
        hasMore={hasMorePolicies}
        loadMore={loadMorePolicies}
        loading={policiesLoading}
      />
    </Box>
    <PermissionsMatrix
      entityTypes={entityTypes}
      userSelector={userSelector}
      selectedPermissions={selectedPermissions}
      setSelectedPermissions={setSelectedPermissions}
      selectedPolicies={selectedPolicies}
    />
  </Stack>
)

export default PermissionGrantForm
